import React from 'react'
import styles from './serviceCard.module.css'
import { LuSparkle } from "react-icons/lu";
import { Link } from 'react-router-dom';

function ServiceCard({
    title,
    description,
    image,
    price,
    cta,
    options = []
}) {
  return (
    <div className={styles.container}>
        <div className={styles.headerContainer}>
            <div className={styles.headerInnerContainer}>
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.description}>{description}</p>
            </div>

            <div className={styles.priceContainer}>
                <div className={styles.priceDetails}>
                    <p className={styles.startsAt}>Starts At:</p>
                    <p className={styles.price}>${price}</p>
                </div>
                {image && (
                    <div className={styles.imageContainer}>
                        <div className={styles.imageWrapper}>
                            <img src={image} alt={title} className={styles.image} />
                        </div>
                    </div>
                )}
            </div>
        </div>

        <Link to="/book" className={styles.cta}>{cta}</Link>

        {options.length > 0 && (
            <div className={styles.options}>
            {options.map((option, index) => (
                <div key={index} className={styles.option}>
                    <LuSparkle />
                    <p>{option}</p>
                </div>
            ))}
            </div>
        )}
    </div>
  )
}

export default ServiceCard
